import { useMemo } from "react";
import { useWeeklyQuestCards } from "../context/WeeklyQuestCardsContextBase";
import { useWeeklyDungeons } from "../context/WeeklyDungeonsContextBase";
import { getWeeklyLegendaryAvailability } from "../utility/weeklyLegendaryAvailability";

export const useWeeklyLegendaryAvailability = () => {
  const {
    cards,
    loaded: cardsLoaded
  } = useWeeklyQuestCards();
  const {
    dungeons,
    loaded: dungeonsLoaded,
    userState: dungeonState
  } = useWeeklyDungeons();

  return useMemo(
    () => getWeeklyLegendaryAvailability({
      cards,
      cardsLoaded,
      dungeons,
      dungeonsLoaded,
      dungeonState
    }),
    [cards, cardsLoaded, dungeons, dungeonsLoaded, dungeonState]
  );
};
